function getFileExtension(path) {
  const cleanPath = path.split('?')[0].split('#')[0];
  const dotIndex = cleanPath.lastIndexOf('.');
  return dotIndex !== -1 ? cleanPath.slice(dotIndex + 1).toLowerCase() : '';
}

export default getFileExtension;
